// extracted by mini-css-extract-plugin
module.exports = {"favouriteButton":"_Favourite_favouriteButton__-cbZK","favouriteIcon":"_Favourite_favouriteIcon__3T1yC","toolbarFavouriteIcon":"_Favourite_toolbarFavouriteIcon__3Wm3E"};